<template>
  <div class="question-select">
    <label v-for="(answer, index) in parameters.possibleAnswers"
      :key="index"
      class="question-select__container"
    >
      <input
        v-model="selectedId"
        class="question-select__radio"
        type="radio"
        :value="answer.id"
        :name="`tipi-id${id}`"
        :disabled="disabled"
      />
      <div
        class="question-select__answer"
        :class="{ 'question-select__answer--disabled': disabled }"
        v-ripple
      >
        <span>{{ answer.title }}</span>
        <v-icon color="white">mdi-check</v-icon>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    parameters: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      answerId: '',
    };
  },

  computed: {
    selectedId: {
      get() {
        return this.parameters.currentAnswer ? this.parameters.currentAnswer : this.answerId;
      },
      set(newAnswerId) {
        this.answerId = newAnswerId;
        this.emmitFormattedAnswer();
      },
    },
  },

  methods: {
    emmitFormattedAnswer() {
      const formattedAnswer = {
        question_id: this.id,
        value: {
          possible_answer_id: this.answerId,
        },
      };
      this.$emit('input', formattedAnswer);
    },
  },
};
</script>

<style lang="scss" scoped>
.question-select {
  &__answer {
    background: #FCFCFC;
    border: 1px solid #E2E6EA;
    color: $main--text;
    margin-bottom: 8px;
    min-height: 32px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    line-height: 14px;
    padding: 0 24px;
    cursor: pointer;
    transition: all 0.2s ease;

    &--disabled {
      cursor: default;
    }
  }

  &__radio {
    opacity: 0;
    position: absolute;

    &:checked ~ .question-select__answer{
      background-color: $color--blue;
      border-color: $color--blue;
      color: #fff;
    }
  }
}
</style>
